import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  private loadingCounter = 0;

  show(): void {
 
    this.loadingCounter++;
    if (this.loadingCounter === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
 
    if (this.loadingCounter > 0) {
      this.loadingCounter--;
      if (this.loadingCounter === 0) {
        this.loadingSubject.next(false);
      }
    }
  }

  reset(): void {
    this.loadingCounter = 0;
    this.loadingSubject.next(false);
  }
}
